import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { Router, Route, browserHistory, IndexRoute } from 'react-router';
import Home from './components/Home';
import Contact from './components/Contact';
import About from './components/About';
import Clients from './components/Clients';
import Services from './components/Services';
import AboutEducational from './components/AboutEducational';
import AboutRetail from './components/AboutRetail';
import Blog from './components/Blog';
import AboutCustom from './components/AboutCustom';
import BlogDetails from './components/BlogDetails';
import ContactFull from './components/ContactFull';



ReactDOM.render(
    <Router onUpdate={() => window.scrollTo(0, 0)} history={browserHistory}>
        <Route path="/" component={App}>
            <IndexRoute component={Home} />
            <Route path="/contact" component={Contact} />
            <Route path="/about" component={About} />
            <Route path="/clients" component={Clients} />
            <Route path="/services" component={Services} />
            <Route path="/solutions/educational" component={AboutEducational} />
            <Route path="/solutions/retail" component={AboutRetail} />
            <Route path="/solutions/custom" component={AboutCustom} />
            <Route path="/blog(/:idCategoria)" component={Blog} />
            <Route path="/blog/post/:id" component={BlogDetails} />
            <Route path="/contact/:type" component={ContactFull} />
        </Route>
    </Router>,
    document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js